import React from 'react';
import ReactDOM from 'react-dom';

import { RouterProvider } from './contexts/routerContext'
import { WidgetProvider } from './contexts/widgetContext'

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider>
      <WidgetProvider>
        <App />
      </WidgetProvider>
    </RouterProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
